import { useCounter } from "@mantine/hooks"
import { useEffect, useState } from "react"
import { FileSection } from "./FileList.types"
import { AppFlavor } from "../../miscellaneous/types"

export const useFileQuery = (token: string, sectionToKeep: FileSection) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const [files, setFiles] = useState<
    {
      id: string
      description: string
      link: string
      section: FileSection
      apps: AppFlavor[]
      visibleTo: "master" | "guest"
      kind: "file" | "link"
    }[]
  >([])

  const [counter, { increment }] = useCounter(0)

  useEffect(() => {
    fetch("https://resinglass-api.igloo.ooo/resources", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        setFiles(
          (response ?? []).filter(
            ({ section }: { section: FileSection }) =>
              section === sectionToKeep,
          ),
        )
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }, [token, counter, sectionToKeep])

  return { loading, error, files, refetch: increment }
}
